module.exports = __webpack_public_path__ + "img/20241124_dongzhuer.148b9961.jpg";